"use strict";

angular.module("customer")
.directive("stockListing", function() {
    return {
        restrict: "E",
        templateUrl: require("./stock-listing.directive.html"),
        controllerAs: "stockListingCtrl",
        scope: true,
        controller: function(
            $scope, $rootScope, $stateParams, $state, $q, $timeout, FlashBag, gettextCatalog, UserService, ModalService,
            StocksService, NoOrderNotificationService, OrderTemplateService,
            VendorInventoryExternalSyncService, CartVendorService, CartItemService, common,
            PRODUCT_ACQUISITION_METHOD, INVENTORY_SYNC_QUEUE_START_MS_DELAY
        ) {
            var _this = this;
            var promises = [];

            $scope.disabled = false;
            $scope.fetching = false;
            $scope.useQuickOrder = false;
            $scope.pagination = {};
            $scope.isSearch = !!$stateParams.search;
            $scope.PRODUCT_ACQUISITION_METHOD = PRODUCT_ACQUISITION_METHOD;
            $scope.lastCatalogId = $stateParams.lastCatalog;

            var userPromise = UserService.isUserFetched().then(function onSuccess(user) {
                $scope.user = user;
                $scope.useQuickOrder = user.info && user.info.customer_use_quick_order;
            });
            promises.push(userPromise);

            this.saveCartVendorAndRefreshStock = function(vendor) {
                if (!vendor.is_standing_order) {
                    _this.refreshCatalogEntries(vendor);
                }
                else if (vendor.is_standing_order && vendor.delivery_date !== vendor.initial_delivery_date) {
                    // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
                    ModalService.showModal({
                        templateUrl: require("core/confirmation/confirmation.modal.html"),
                        controller: "Confirmation",
                        controllerAs: "ConfirmationCtrl",
                        inputs: {
                            $attrs: {
                                title: gettextCatalog.getString("Cancel standing order"),
                                message: gettextCatalog.getString("If you change the delivery date, this standing order will be cancelled."),
                                confirmTextButton: gettextCatalog.getString("Confirm")
                            }
                        }
                    }).then(function onSuccess(modal) {
                        modal.element.modal({
                            backdrop: "static",
                            keyboard: false
                        });
                        modal.close.then(function(confirm) {
                            vendor.cancelStandingOrder = false;
                            if (confirm) {
                                vendor.cancelStandingOrder = true;
                                _this.refreshCatalogEntries(vendor);
                            }
                            else {
                                vendor.delivery_date = vendor.initial_delivery_date;
                            }
                        });
                    });
                }
            };

            this.refreshCatalogEntries = function(vendor) {
                $scope.pagination = {};
                if (vendor) {
                    vendor.isDeliveryDateValid = true;
                    if (vendor.today_delivery_day && vendor.delivery_date === vendor.today_delivery_day.delivery_date) {
                        vendor.threshold_datetime = null;
                    }
                }
                $scope.$emit("doRefreshVendor", vendor);
            };

            this.getMoreCatalogEntries = function() {
                if (typeof $scope.pagination.num_pages === "undefined") {
                    search();
                }
                else if ($scope.pagination.current_page === $scope.pagination.num_pages || $scope.pagination.num_pages === 1) {
                    $scope.disabled = true;
                }
                else if ($scope.pagination.num_pages > 1) {
                    $scope.pagination.current_page++;
                    search();
                }
                else {
                    $scope.disabled = true;
                }
            };

            this.ignoreInvalidDeliveryWarning = function(vendor) {
                vendor.is_delivery_date_updated = false;
                vendor.has_valid_rule = true;
            };

            function mergeCatalogEntriesToVendors(catalogEntries) {
                if (!$scope.Vendors) {
                    return;
                }

                $scope.Vendors.some(function(vendor) {
                    if (!vendor.catalogEntries) {
                        vendor.catalogEntries = [];
                    }
                    angular.forEach(catalogEntries, function(value, key) {
                        if (value.product.vendor_id == vendor.id) {
                            vendor.catalogEntries.push(value);
                            vendorProductAdded(vendor, value.product.id);
                        }
                    });
                    StocksService.updateDeliveryData(vendor);
                });
            }

            function vendorProductAdded(vendor, product_id) {
                if ($scope.isInventoryValidationRequired && vendor.has_external_sync_config) {
                    if (!vendor.inventorySyncQueue) {
                        vendor.inventorySyncQueue = [];
                        $timeout(function() {
                            syncVendorExternalInventory(vendor);
                        }, INVENTORY_SYNC_QUEUE_START_MS_DELAY);
                    }
                    vendor.inventorySyncQueue.push(product_id);
                }
            }

            function fireQuickOrder() {
                $q.all(promises).then(function onSuccess() {
                    if ($scope.isSearch && $scope.useQuickOrder) {
                        $timeout(function() {
                            var offset = -100;
                            if (angular.element("ordered-quantity .value-select").size()) {
                                common.scrollTo(".stock-product-block:first-of-type", offset);
                                angular.element("ordered-quantity .value-select").first().focus().select();
                            }
                            else if (angular.element("returned-quantity .value-select").size()) {
                                common.scrollTo(".stock-product-block:first-of-type", offset);
                                angular.element("returned-quantity .value-select").first().focus().select();
                            }
                            else {
                                $("html, body").animate({scrollTop: 0}, "slow");
                            }
                        });
                    }
                });
            }

            var unregisterQuickOrder = $scope.$on("quickOrderQuantity:ready", function() {
                unregisterQuickOrder();
                fireQuickOrder();
            });

            $scope.$on("$destroy", function() {
                unregisterQuickOrder();
            });

            function syncVendorExternalInventory(vendor) {
                var productIds = vendor.inventorySyncQueue;
                vendor.inventorySyncQueue = null;
                if (!productIds) {
                    return;
                }

                VendorInventoryExternalSyncService.syncProductInventory(vendor.id, productIds)
                .then(function onSuccess(response) {
                    if (!response.data || response.data && response.data.length === 0) {
                        return;
                    }

                    var productsInventoriesMapping = {};
                    var productsInventories = response.data;
                    angular.forEach(productsInventories, function(value, key) {
                        productsInventoriesMapping[value.product_id] = value.inventory_quantity;
                    });

                    angular.forEach(vendor.catalogEntries, function(value, key) {
                        if (value.product.id in productsInventoriesMapping) {
                            value.minimal_available_quantities = [];
                            value.inventory_quantity = productsInventoriesMapping[value.product.id];
                        }
                    });
                });
            }

            function search() {
                $scope.fetching = true;
                $scope.$emit("doUpdateSort", false, $scope.sortBy.selected);
                var fetchService = StocksService.fetchSales;
                if (!$scope.isOrderTemplate && $scope.activeTab === $scope.TABS.RETURNS) {
                    fetchService = StocksService.fetchReturns;
                }
                else if (!$scope.isOrderTemplate && $scope.activeTab === $scope.TABS.INVENTORY_RETURNS) {
                    fetchService = StocksService.fetchInventoryReturns;
                }
                else if (!$scope.isOrderTemplate && $scope.activeTab === $scope.TABS.CUSTOM_DISCOUNTS) {
                    fetchService = StocksService.fetchDiscounts;
                }

                fetchService($scope.searchSortBy, $scope.pagination.current_page).$promise.then(
                    function onSuccess(paginationData) {
                        if (paginationData.pagination.count) {
                            $scope.pagination = paginationData.pagination;
                            mergeCatalogEntriesToVendors(paginationData.results);
                            $scope.$emit("doUpdateSort", true);
                            $scope.fetching = false;
                        }
                        else {
                            var message;
                            if ($scope.isSearch) {
                                message = gettextCatalog.getString("Sorry, but we didn't find any product meeting the search criteria \"{{search}}\".", {search: $stateParams.search});
                            }
                            else {
                                message = gettextCatalog.getString("You have no product.");
                            }
                            FlashBag.preformattedWarning(message, "");
                        }
                    }, function onError() {
                        $scope.$emit("doUpdateSort", true);
                        $scope.fetching = false;
                        $scope.disabled = true;
                    }
                );
            }

            this.usePreviousOrder = function(vendor, $event) {
                $event.preventDefault();
                if (!StocksService.validateDeliveryDate(vendor)) {
                    return
                }

                // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
                ModalService.showModal({
                    templateUrl: require("./use-previous-order.modal.html"),
                    controller: "UsePreviousOrderController",
                    controllerAs: "usePreviousOrderCtrl",
                    inputs: {
                        $attrs: {
                            vendorName: vendor.Name,
                            dateLastOrder: vendor.last_order_date
                        }
                    }
                }).then(function(modal) {
                    modal.element.modal({
                        backdrop: "static",
                        keyboard: false
                    });
                    modal.close.then(function(confirm) {
                        if (confirm) {
                            CartItemService.usePreviousOrder({vendor_id: vendor.id}).then(
                                function onSuccess() {
                                    $state.go("shoppingCart");
                                },
                                function onError(response) {
                                    FlashBag.apiError(response);
                                }
                            );
                        }
                    });
                });
            };

            this.generateCartFromOrderTemplate = function(templateId) {
                // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
                ModalService.showModal({
                    templateUrl: require("core/confirmation/confirmation.modal.html"),
                    controller: "Confirmation",
                    controllerAs: "ConfirmationCtrl",
                    inputs: {
                        $attrs: {
                            title: gettextCatalog.getString("Create order"),
                            message: gettextCatalog.getString("Do you really want to create an order from this template?"),
                            confirmTextButton: gettextCatalog.getString("Create order")
                        }
                    }
                }).then(function onSuccess(modal) {
                    modal.element.modal({
                        backdrop: "static",
                        keyboard: false
                    });
                    modal.close.then(function(confirm) {
                        if (!confirm) {
                            return;
                        }
                        OrderTemplateService.generateCartFromOrderTemplate(templateId).then(
                            function onSuccess(response) {
                                FlashBag.success(gettextCatalog.getString("The cart was generated successfully."), true);
                                if (response.data && response.data.missing_products && response.data.missing_products.length) {
                                    var warningMessage = gettextCatalog.getPlural(
                                        response.data.missing_products.length,
                                        "The product below is not accessible:",
                                        "The products below are not accessible:"
                                    );
                                    OrderTemplateService.showMissingProductsWarning(response.data.missing_products, warningMessage);
                                }
                                $rootScope.UpdateCurrentNumbers();
                                $state.go('shoppingCart');
                            },
                            function onError(response) {
                                FlashBag.apiError(response);
                            }
                        );
                    });
                });
            };

            this.resetInventory = function(vendor, $event) {
                $event.preventDefault();
                if (!StocksService.validateDeliveryDate(vendor)) {
                    return
                }

                if ($scope.currentView !== "inventory") {
                    return;
                }

                // noinspection JSVoidFunctionReturnValueUsed,JSCheckFunctionSignatures
                ModalService.showModal({
                    templateUrl: require("core/confirmation/confirmation.modal.html"),
                    controller: "Confirmation",
                    controllerAs: "selector",
                    inputs: {
                        $attrs: {
                            title: gettextCatalog.getString("Reset Inventory"),
                            message: gettextCatalog.getString("You about to reset all product's inventories to zero for this vendor. Are you sure?")
                        }
                    }
                }).then(function(modal) {
                    modal.element.modal();
                    modal.element.on("hidden.bs.modal", function(e) {
                        modal.element.remove();
                    });
                    modal.close.then(function(result) {
                        if (result) {
                            StocksService.resetInventory(vendor.id).then(function onSuccess() {
                                _this.refreshCatalogEntries(vendor);
                            });
                        }
                    });
                });
            };

            this.isNoOrderNotificationButtonAvailable = function(vendor) {
                return vendor.has_no_order_notification_configuration && !this.isOrderExistsWithCurrentDeliveryDate(vendor)
            };

            this.openNoOrderNotificationConfirmation = function(vendor) {
                // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
                ModalService.showModal({
                    templateUrl: require("../order/no-order-notification/modals/no-order-notification.modal.html"),
                    controller: "NoOrderNotificationConfirmationController",
                    controllerAs: "noOrderNotificationConfirmationCtrl",
                    inputs: {
                        $attrs: {
                            vendorName: vendor.Name,
                            deliveryDate: vendor.delivery_date,
                        }
                    }
                }).then(function(modal) {
                    modal.element.modal({
                        backdrop: "static",
                        keyboard: false
                    });
                    modal.close.then(function(confirm) {
                        if (!confirm) {
                            return;
                        }

                        NoOrderNotificationService.submitEmptyOrder(
                            vendor.id,
                            vendor.delivery_date
                        ).then(function onSuccess() {
                            var message = gettextCatalog.getString("The no-order notification was sent.");
                            FlashBag.success(message, true);
                            $state.go('home');
                        });
                    });
                });
            };

            this.isOrderExistsWithCurrentDeliveryDate = function(vendor) {
                return vendor.list_of_delivery_dates_with_existing_order.indexOf(vendor.delivery_date) !== -1;
            };

            $scope.$on("doRefreshCatalogEntries", function() {
                _this.refreshCatalogEntries();
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/stock/stock-listing.directive.js
// module id = 925
// module chunks = 0